type NameInput = {
  firstName?: string | null
  lastName?: string | null
}

export function getInitials({ firstName, lastName }: NameInput): string {
  return [firstName, lastName]
    .map((str) => (typeof str === 'string' ? str.charAt(0) : ''))
    .join('')
    .toUpperCase()
}
